import { Completion } from '@codemirror/autocomplete';

export const lgoHydrotreaterCodeCompletions: Completion[] = [
  { label: 'HGOYield', type: 'variable', info: '' },
  { label: 'LGOYield', type: 'variable', info: '' },
  { label: 'NaphthaYield', type: 'variable', info: '' },
  { label: 'H2SProductionRate', type: 'variable', info: '' },
  { label: 'HydrogenUseRate', type: 'variable', info: '' },
];
